import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import Booking from "./Booking";
import Popularplace from "./Popularplace";
import Features from "./Features";
import FAQ from "./FAQ";
import CricbuddyAppComp from "../NewLandingPage/CricbuddyAppComp";
import HelmetMetaTag from "../Utils/HelmetMetaTag/HelmetMetaTag";
import { CustomGetAPI } from "../Utils/APIConnector";
import { useNavigate } from "react-router-dom";
import Popup from "../LiveScoreCardpopups/Popup";
import VenueSearch from "../VenueListing/venueSearch";
import NewVenueSearch from "../VenueListing/NewVenueSearch";
import { handleLocationClick } from "../Utils/common";

export default function Index() {
  const [state, setState] = useState(
    window.localStorage.getItem("userLocation")
  );
  const [show, setShow] = useState({
    popup: false,
    sport: "all",
    event: true,
  });
  const [packageData, setPacakgeData] = useState();
  const [showShadow, setShowShadow] = useState(null);
  const data = (data) => {
    setState(data);
  };
  const userLocation = localStorage.getItem("userLocation")?.split("-")[
    localStorage.getItem("userLocation")?.split("-")?.length - 1
  ];
  useLayoutEffect(() => {
    CustomGetAPI(
      `/Packages/PackageByID/0/0?cityname=${userLocation && userLocation}`
    ).then((result) => {
      result = JSON.parse(result);
      if (result && result?.status == "Success") {
        setPacakgeData(result?.packages[0]);
      }
    });
  }, [userLocation]);

  const navigate = useNavigate();

  const handleSetShow = () => setShow({ ...show, popup: !show.popup });

  const features = [
    "Easy venue selection with clear availability and preferred date/time slots.",
    "Apply discount coupons and complete bookings using secure digital payments.",
    "Easy booking cancellation, refunds or rescheduling without hassle.",
    "Get instant booking updates and confirmations on WhatsApp.",
    "Fast and secure OTP login for a seamless user experience.",
    "Manage your account with complete booking history.",
    "Automated reminders so you never miss your next game.",
    "Search venues by proximity, sport type, or specific filters.",
    "Check reviews & ratings before booking.",
  ];

  const howItWorks = [
    {
      id: 1,
      title: "Browse & Select a Venue",
      desc: "Search by location, sport type, distance, or rating to find the perfect slot.",
    },
    {
      id: 2,
      title: "Choose Date, Time & Apply Discounts",
      desc: "View live availability, pick your slot, and apply available offers.",
    },
    {
      id: 3,
      title: "Pay Online & Get Instant Confirmation",
      desc: "Complete the payment securely and receive updates through WhatsApp and the app.",
    },
    {
      id: 4,
      title: "Manage Your Play Easily",
      desc: "Enjoy recurring bookings, quick cancellations, refunds, reminders, and detailed booking history.",
    },
  ];

  const whyChooseCricBuddy = [
    {
      id: 5,
      title: "Simple, Fast & Intuitive Booking Process",
      desc: "CricBuddy helps you quickly and easily find and book sports venues. Choose your preferred location, check available slots, and confirm your booking in just a few taps — no waiting or back-and-forth calls.",
    },
    {
      id: 6,
      title: "Supports Multiple Sports",
      desc: "Whether you want to play box cricket, cricket net, pickleball, football, badminton, or other popular games, CricBuddy gives you access to multiple sports venues so you can play what you enjoy, anytime.",
    },
    {
      id: 7,
      title: "Massive Venue Network Across India",
      desc: "With 1000+ verified venues, users get unmatched choice and coverage from premium turfs to local community grounds.",
    },

    {
      id: 8,
      title: "Instant Updates and Reminders",
      desc: "CricBuddy sends you instant updates, booking confirmations, and reminders directly on WhatsApp and in-app notifications, so you always stay informed and ready to play.",
    },
    {
      id: 9,
      title: "Trusted Community with Authentic Ratings & Reviews",
      desc: "Every venue and match comes with honest ratings and reviews from other players. This helps you pick the best venues and games, making your experience safe and reliable.",
    },
  ];
  const words = [
    "Box Cricket Turf",
    "Badminton Court",
    "Football Turf",
    "Cricket Net",
    "Cricket Ground",
    "Pickleball Court",
  ];
  const [text, setText] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    const currentWord = words[wordIndex];
    let timeout;

    if (!isDeleting) {
      timeout = setTimeout(() => {
        setText(currentWord.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);

        if (charIndex + 1 === currentWord.length) {
          setTimeout(() => setIsDeleting(true), 1500);
        }
      }, 100);
    } else {
      timeout = setTimeout(() => {
        setText(currentWord.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);

        if (charIndex === 0) {
          setIsDeleting(false);
          setWordIndex((prev) => (prev + 1) % words.length);
        }
      }, 60);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, wordIndex]);
  return (
    <Fragment>
      <HelmetMetaTag
        titleName="CricBuddy | Discover and Book Sports Venues near you Online"
        desc="Find the best sports venues in your city. Check slot availability, view details, book nearby turfs, courts & more sports facilities instantly with cricbuddy."
        canonical={window.location.href}
        ogtitle="CricBuddy | Discover and Book Sports Venues near you Online"
        ogdesc="Find the best sports venues in your city. Check slot availability, view details, book nearby turfs, courts & more sports facilities instantly with cricbuddy."
        ogtype="website"
        ogurl={window.location.href}
        ogimg="https://cricbuddy.in/logo192.png"
      />
      {/* <div className="px-0 row" style={{ overflowX: "hidden" }}> */}
      <div style={{ backgroundColor: "#FFFCFC", overflowX: "hidden" }}>
        <Booking data={data} text={text} />
        <Popularplace data={state} />
        {/* <div className="row mt-3 position-relative">
          <img
            src="/images/PackageBanner.jpg"
            className="img-fluid AuditoriumBaneerBgImg"
            alt=""
          />
          <div className="position-absolute auditoriumBannerText">
            <p
              style={{
                margin: "0px",
                color: "white",
              }}
            >
              {packageData ? (
                <span style={{ color: "#FFF200" }}>Play More, Pay Less:</span>
              ) : (
                <span style={{ color: "#FFF200" }}>
                  {userLocation
                    ? userLocation?.charAt(0)?.toUpperCase() +
                      userLocation?.slice(1)?.toLowerCase()
                    : "Ahmedabad"}
                  , prepare for savings!
                </span>
              )}
              <br />
              {packageData ? (
                <>
                  {packageData?.packageDuration} Hours of Box Cricket for ₹
                  {packageData?.price}
                </>
              ) : (
                <>Our package plan offer is coming soon.</>
              )}
            </p>
            <button
              className="mt-3 auditoriumBannerBtn px-3 py-1 fw-600"
              style={{
                color: "#E7666A",
                background: "#FFFFFF",
                border: "none",
                padding: "3px 5px",
                marginTop: "15px",
                borderRadius: "3px",
              }}
              onClick={() => {
                window.location.href = "/packages";
                // if (userLocation) {
                //   navigate(
                //     `/venue-search/${userLocation.toLocaleLowerCase()}/events/auditorium`
                //   );
                // } else {
                //   setShow({ popup: true, sport: "auditorium", event: true });
                // }
              }}
            >
              Know more
            </button>
          </div>
        </div> */}
        <div className="row px-md-5 px-2 position-relative mt-3 mt-md-4 gap-4 gap-md-0">
          <div className="col-md-6 position-relative">
            <img
              src="/images/PackageBanner_2.png"
              // className="img-fluid AuditoriumBaneerBgImg"
              className="img-fluid w-100"
              alt=""
            />
            {/* <div className="position-absolute auditoriumBannerText"> */}
            <div className="position-absolute auditoriumBannerText-new">
              <p
                style={{
                  margin: "0px",
                  color: "white",
                }}
              >
                {packageData ? (
                  <span
                    className="font-22 font-medium"
                    style={{ color: "#FFF200" }}
                  >
                    Play More, Pay Less:
                  </span>
                ) : (
                  <span style={{ color: "#FFF200" }}>
                    {userLocation
                      ? userLocation?.charAt(0)?.toUpperCase() +
                        userLocation?.slice(1)?.toLowerCase()
                      : "Ahmedabad"}
                    , prepare for savings!
                  </span>
                )}
                <br />
                {packageData ? (
                  <>
                    {packageData?.packageDuration} Hours of Box Cricket for ₹
                    {packageData?.price}
                  </>
                ) : (
                  <>Our package plan offer is coming soon.</>
                )}
              </p>
              <button
                className="mt-3 auditoriumBannerBtn px-3 py-2 fw-600"
                style={{
                  color: "#E7666A",
                  background: "#FFFFFF",
                  border: "none",
                  padding: "3px 5px",
                  marginTop: "15px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  navigate(`/packages`);
                }}
              >
                Know more
              </button>
            </div>
          </div>
          {/* {(userLocation == "ahmedabad" || !userLocation) && ( */}
          <div className="col-md-6 position-relative">
            <img
              src="/images/AuditoriumBaner_2.png"
              // className="img-fluid AuditoriumBaneerBgImg"
              className="img-fluid w-100"
              alt=""
              style={{ borderRadius: "8px" }}
            />
            {/* <div className="position-absolute auditoriumBannerText"> */}
            <div className="position-absolute auditoriumBannerText-new">
              <p
                style={{
                  margin: "0px",
                  color: "white",
                }}
              >
                Looking for a small Auditorium to organize <br /> or host an
                event?
              </p>
              <button
                className="mt-3 auditoriumBannerBtn px-3 py-2 fw-600"
                style={{
                  color: "#E7666A",
                  background: "#FFFFFF",
                  border: "none",
                  padding: "3px 5px",
                  marginTop: "15px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  if (!userLocation) {
                    setShow({ popup: true, sport: "all" });
                    // handleLocationClick(true, "all", navigate, handleSetShow, userLocation)
                  } else {
                    navigate(`/venue-search/${userLocation}/events/all`);
                  }
                }}
              >
                Book Auditorium
              </button>
            </div>
          </div>
          {/* )} */}
        </div>
        <div className="pt-5">
          <h2 className="latestlandingpage-features-h4 mx-md-0 mx-4 text-center mb-3">
            About Cricbuddy
          </h2>
          <div className="row mt-md-0 mt-2 mx-md-auto mx-2 align-items-center">
            <div className="col-12 col-md-6 text-center mb-4 ps-md-5">
              <div className="mb-3 ">
                CricBuddy is India's fastest growing multi-sports venue booking
                platform & mobile app that connects sports enthusiasts directly
                with venues and other players.
              </div>
              <div className="">
                We are now available in 30+ cities with 1,000+ registered venues
                and counting across India with thousands of active players. Use
                CricBuddy to easily discover sports venues near you, check
                available slots, and book instantly online.
              </div>
            </div>
            <div className="col-12 col-md-6 text-center mb-4">
              <img
                className="img-fluid"
                src="/images/aboutcbimage.png"
                alt=""
              />
            </div>
            <div className="col-12 col-md-8 offset-md-2 mb-4">
              <h2 className="latestlandingpage-features-h4 mx-md-0 mx-4 text-center mb-3">
                Key Features
              </h2>
              <div className="row">
                {features.map((text, index) => (
                  <div className="col-md-4 col-12" key={index}>
                    <div className="d-flex align-items-start py-1 mb-2">
                      <img
                        src="/images/cricketball.svg"
                        alt="cricketball"
                        style={{ paddingTop: "0.35rem" }}
                      />
                      <label className="ps-2">{text}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12 col-md-8 offset-md-2 mb-4">
              <h2 className="latestlandingpage-features-h4 mx-md-0 mx-4 text-center mb-3">
                How it Works
              </h2>
              <h4 className="text-center mb-3">
                4 Easy Steps to Book your Sports Venue
              </h4>
              <div className="row">
                {howItWorks.map((item, index) => (
                  <div className="col-12 col-md-6 mb-3 mb-md-4">
                    <div
                      className={`d-flex align-items-start rounded-3 h-100 p-3 border cursor-pointer ${
                        showShadow == item.id ? "shadow" : ""
                      }`}
                      key={index}
                      onMouseEnter={() => setShowShadow(item.id)}
                      onMouseLeave={() => setShowShadow(null)}
                    >
                      <h5>0{item.id}.</h5>
                      <div className="ps-2">
                        <h5 className="w-100">{item.title}</h5>
                        <label className="w-100">{item.desc}</label>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12 col-md-8 offset-md-2">
              <h2 className="latestlandingpage-features-h4 mx-md-0 mx-4 text-center mb-3">
                Why Choose Cricbuddy
              </h2>
              <div className="row">
                {whyChooseCricBuddy?.map((item, index) => (
                  <div
                    className={`col-12 col-md-4 ${
                      index === 3 ? "offset-md-2" : ""
                    } mb-3 mb-md-4`}
                  >
                    <div
                      className={`rounded-3 h-100 p-3 border cursor-pointer ${
                        showShadow == item.id ? "shadow" : ""
                      }`}
                      key={index}
                      onMouseEnter={() => setShowShadow(item.id)}
                      onMouseLeave={() => setShowShadow(null)}
                    >
                      <h5>{item.title}</h5>
                      <label className="pt-2">{item.desc}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Features />
        <CricbuddyAppComp />
        <FAQ />
      </div>
      <Popup
        show={show?.popup}
        onHide={() => setShow({ popup: false, sport: "all" })}
      >
        {/* <VenueSearch isevent={"true"} sport={show?.sport} /> */}
        <NewVenueSearch isevent={"true"} sport={show?.sport} />
      </Popup>
      {/* </div> */}
    </Fragment>
  );
}
